import React from 'react';
import { styled } from '@mui/material/styles';
import 'date-fns';
import Grid from '@mui/material/Grid';
import 'date-fns';
import Typography from '@mui/material/Typography';
import Icon from '@mui/material/Icon';
import Button from '@mui/material/Button';
import PaymentTable from '../Payments/PaymentTable';
import AdvertisementCardGrid from '../CampaignAdvertisements/AdvertisementCardGrid';
import routes from '../../../../constants/Routes';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { CampaignState, createCampaignAction, updateCampaignAction } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
import { useNavigate } from 'react-router-dom';

const PREFIX = 'ViewCampaignDetails';

const classes = {
    formControl: `${PREFIX}-formControl`,
    root: `${PREFIX}-root`,
    button: `${PREFIX}-button`,
    heading: `${PREFIX}-heading`,
    completed: `${PREFIX}-completed`,
    instructions: `${PREFIX}-instructions`,
    textField: `${PREFIX}-textField`,
    baseInputField: `${PREFIX}-baseInputField`,
    formControlsCampaign: `${PREFIX}-formControlsCampaign`,
    gridborder: `${PREFIX}-gridborder`,
    gridborder1: `${PREFIX}-gridborder1`,
    gridborder2: `${PREFIX}-gridborder2`,
    adplaytextfield: `${PREFIX}-adplaytextfield`,
    titlecampaign: `${PREFIX}-titlecampaign`,
    paddingTextfield: `${PREFIX}-paddingTextfield`,
    paddingTextArea: `${PREFIX}-paddingTextArea`,
    reviewOuterGrid: `${PREFIX}-reviewOuterGrid`,
    reviewHeading: `${PREFIX}-reviewHeading`,
    table: `${PREFIX}-table`,
    campaignHeading: `${PREFIX}-campaignHeading`,
    campaignHeadingGrid: `${PREFIX}-campaignHeadingGrid`,
    advertisementHeading: `${PREFIX}-advertisementHeading`,
    campaignHeadings: `${PREFIX}-campaignHeadings`,
    paymentHeadings: `${PREFIX}-paymentHeadings`,
    paymentHeadingGrid: `${PREFIX}-paymentHeadingGrid`,
    tableGrid: `${PREFIX}-tableGrid`,
    reviewData: `${PREFIX}-reviewData`,
    advertisementAddGrid: `${PREFIX}-advertisementAddGrid`,
    cardparent: `${PREFIX}-cardparent`,
    gridListRoot: `${PREFIX}-gridListRoot`,
    gridList: `${PREFIX}-gridList`,
    gridlisttile: `${PREFIX}-gridlisttile`,
    adtile: `${PREFIX}-adtile`,
    reviewSubmitButton: `${PREFIX}-reviewSubmitButton`,
    formElement: `${PREFIX}-formElement`,
    mainDetailsBox: `${PREFIX}-mainDetailsBox`,
    advListGrid: `${PREFIX}-advListGrid`,
    saveGrid: `${PREFIX}-saveGrid`
};

const StyledGrid = styled(Grid)((
    {
        theme
    }
) => ({
    [`& .${classes.formControl}`]: {
        minWidth: '100%',
    },

    [`& .${classes.root}`]: {
        width: '100%',
    },

    [`& .${classes.button}`]: {
        marginRight: theme.spacing(1),
    },

    [`& .${classes.heading}`]: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'lighter',
    },

    [`& .${classes.completed}`]: {
        display: 'inline-block',
    },

    [`& .${classes.instructions}`]: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },

    [`& .${classes.textField}`]: {
        marginTop: theme.spacing(2),
        width: '100%',
    },

    [`& .${classes.baseInputField}`]: {
        width: '100%',
        marginTop: theme.spacing(1.5),
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
    },

    [`& .${classes.formControlsCampaign}`]: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        width: '95%',
    },

    [`& .${classes.gridborder}`]: {
        border: '1px inset #757575',
        padding: theme.spacing(1),
        margin: theme.spacing(1),
    },

    [`& .${classes.gridborder1}`]: {
        padding: '3px',
        boxShadow: '5px 10px 10px #e0e0e0',
    },

    [`& .${classes.gridborder2}`]: {
        border: '1px inset #fafafa',
        padding: '5px',
    },

    [`& .${classes.adplaytextfield}`]: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        width: '97%',
    },

    [`& .${classes.titlecampaign}`]: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(1),
    },

    [`& .${classes.paddingTextfield}`]: {
        padding: '5px',
        flexGrow: 1,
    },

    [`& .${classes.paddingTextArea}`]: {
        padding: '5px',
        flexGrow: 1,
        height: '10em',
    },

    [`&.${classes.reviewOuterGrid}`]: {
        boxShadow: `0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 100px 80px rgba(0, 0, 0, 0.12)`,
        border: '1px solid #9e9e9e',
    },

    [`& .${classes.reviewHeading}`]: {
        //color: '#1565c0'
    },

    [`& .${classes.table}`]: {
        minWidth: 700,
    },

    [`& .${classes.campaignHeading}`]: {
        padding: '5px',
        color: '#ffffff',
    },

    [`& .${classes.campaignHeadingGrid}`]: {
        backgroundColor: '#085DAD',
    },

    [`& .${classes.advertisementHeading}`]: {
        padding: '5px',
        marginTop: '10px',
        backgroundColor: '#bbdefb',
    },

    [`& .${classes.campaignHeadings}`]: {
        paddingLeft: '5px',
        marginTop: theme.spacing(2),
    },

    [`& .${classes.paymentHeadings}`]: {
        paddingLeft: '5px',
        marginTop: theme.spacing(2),
        paddingBottom: '5px',
    },

    [`& .${classes.paymentHeadingGrid}`]: {
        backgroundColor: '#bbdefb',
    },

    [`& .${classes.tableGrid}`]: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(3),
    },

    [`& .${classes.reviewData}`]: {
        marginLeft: theme.spacing(1),
    },

    [`& .${classes.advertisementAddGrid}`]: {
        marginTop: '7px',
        marginLeft: '7px',
    },

    [`& .${classes.cardparent}`]: {
        maxWidth: 220,
        border: '1px solid #000000',
    },

    [`& .${classes.gridListRoot}`]: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },

    [`& .${classes.gridList}`]: {
        flexWrap: 'nowrap',
        transform: 'translateZ(0)',
        justifyContent: 'flex-start',
    },

    [`& .${classes.gridlisttile}`]: {},

    [`& .${classes.adtile}`]: {
        border: '1px solid #000000',
        width: '200px',
        height: '200px',
        marginLeft: '2px',
    },

    [`& .${classes.reviewSubmitButton}`]: {
        marginTop: '10px',
        marginLeft: '10px',
    },

    [`& .${classes.formElement}`]: {
        minWidth: '100%',
        //padding: theme.spacing(1)
        marginTop: theme.spacing(3),
    },

    [`& .${classes.mainDetailsBox}`]: {
        borderRadius: '10px',
        border: '1px solid #085DAD',
        backgroundColor: '#ddeef6',
        padding: theme.spacing(2),
        marginLeft: theme.spacing(2),
    },

    [`& .${classes.advListGrid}`]: {
        padding: theme.spacing(2),
        margingLeft: theme.spacing(2),
    },

    [`& .${classes.saveGrid}`]: {
        margingTop: theme.spacing(4),
        padding: theme.spacing(3),
    }
}));

const ViewCampaignDetails = ({ handleBack }: { handleNext: any; handleBack: any }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
	const campaignStore: CampaignState = useAppSelector((state: RootState) => state.campaign);
	const { mode: action, campaign } = campaignStore;
	const handleSubmit = () => {
		if (action === 'VIEW') {
      navigate(routes.CAMPAIGN_LIST.path);

		} else {
			if (action === 'EDIT') {
				dispatch(updateCampaignAction(campaign));

			} else {
				dispatch(createCampaignAction(campaign));

			}
		}
	};
	return (
        <StyledGrid container direction="row" xs={12} className={classes.reviewOuterGrid}>
			<Grid
				item
				container
				xs={12}
        style={{backgroundColor: '#042630'}}
				justifyContent="center"
				alignItems="center"
				className={classes.campaignHeadingGrid}>
				<Grid item container xs={12} justifyContent="center" alignItems="center">
					<Typography variant="h4" className={classes.campaignHeading}>
						{campaign.name && campaign.name.toUpperCase()}
					</Typography>
				</Grid>
				<Grid item container xs={12} justifyContent="center" alignItems="center">
					<Typography variant="h6" className={classes.campaignHeading}>
						{campaign &&
							campaign.client &&
							campaign.client.name &&
							campaign.client.name.toUpperCase()}
					</Typography>
				</Grid>
			</Grid>

			<Grid container item xs={12} className={classes.tableGrid}>
				<AdvertisementCardGrid />
			</Grid>
			<Grid container item xs={12} className={classes.tableGrid}>
				<PaymentTable payments={campaign.payments} isActionsEnabled={false} />
			</Grid>
			{action === 'VIEW' ? (
				<>
					<Grid
						container
						item
						direction="row"
						justifyContent="space-around"
						className={classes.saveGrid}>
						<Grid item>
							<Button
								className={classes.formElement}
								variant="contained"
								onClick={handleSubmit}
								color="primary">
								{' '}
								CLOSE{' '}
							</Button>
						</Grid>
					</Grid>
				</>
			) : (
				<>
					<Grid
						container
						item
						direction="row"
						justifyContent="space-around"
						className={classes.saveGrid}>
						<Grid item>
							<Button
                style={{borderColor:"#042630",color:"#000000"}}
								variant="outlined"
								className={classes.formElement}
								onClick={handleBack}>
								BACK
							</Button>
						</Grid>
						<Grid item>
							<Button
								className={classes.formElement}
								variant="contained"
								onClick={handleSubmit}
                style={{backgroundColor:"#042630",color:"#ffffff"}}
								endIcon={<Icon>send</Icon>}>
								{action === 'EDIT' ? 'SUBMIT' : 'SUBMIT'}
							</Button>
						</Grid>
					</Grid>
				</>
			)}
		</StyledGrid>
    );
};

export default ViewCampaignDetails;
